// Titoli abbreviati con la grafia corretta (es. "dott.ssa" -> "Dott.ssa", non "Dott.Ssa").
const TITOLI = ["Dott.ssa", "Dr.ssa", "Avv.ta", "Prof.ssa", "Dir.ssa", "Sig.ra", "Sig.na", "Gent.mo", "Gent.ma", "Gent.mi", "Gent.me",
  "Spett.le", "Ill.mo", "Ill.ma", "Ch.mo", "Ch.ma", "Egr.", "Dott.", "Dr.", "Avv.", "Geom.", "Ing.", "Arch.", "Rag.", "Prof.", "Sig.",
  "Dir.", "Pres.", "Cav.", "Comm.", "Mons.", "Geol.", "Agr."];
const CANON = Object.fromEntries(TITOLI.map((t) => [t.toLowerCase(), t]));
const RX = new RegExp(`(?<!\\p{L})(${TITOLI.map((t) => t.replace(/\./g, "\\.")).join("|")})(?![\\p{Ll}])`, "giu");

export const fixTitoli = (s) => String(s || "").replace(RX, (m) => CANON[m.toLowerCase()] || m);
